import React, { useState } from 'react';
import { Modal, Button, DatePicker } from 'antd';
import moment from 'moment';

import { Rive } from '../RiveComponent/index';
import { LogsBackupWrapper } from './style';

const LogsAndBackupModal = ({ visible, isLogs, step, onCancel, handleRedirect, handleLogs, isLogsDisabled }) => {
    const dateFormat = 'YYYY/MM/DD';
    const [startDate, setStartDate] = useState(moment().subtract(1, 'days').format());
    const [endDate, setEndDate] = useState(moment().format());

    const handleDate = (value) => {
        if (value) {
            const start_date = moment(value[0]).format();
            const end_date = moment(value[1]).format();
            setStartDate(start_date);
            setEndDate(end_date)
        }
    }

    const renderBackup = () => {
        return (
            <div className='backup-wrapper'>
                <Rive src={'backupLog.riv'} />
                <div className="step-2-container">
                    {isLogs
                        ? <div className="header-txt">Getting logs...</div>
                        : <div className="header-txt">Getting database backup...</div>
                    }
                    <div>
                        An email will be set with the logs download link once the data retrieval completes. Please check your email in a few minutes.
                    </div>
                    <div className="btn-wrapper">
                        <Button
                            type='primary'
                            onClick={handleRedirect}
                        >
                            Go to events
                        </Button>
                    </div>
                </div>
            </div>
        )
    }

    const renderBody = () => {
        switch (step) {
            case 2:
                return (
                    <LogsBackupWrapper>
                        {renderBackup()}
                    </LogsBackupWrapper>
                )
            case 1:
            default:
                return (
                    <LogsBackupWrapper>
                        {isLogs
                            ?
                            <div className="step-1-container">
                                <div className="header-txt">Download logs</div>
                                <div className='sub-txt'>
                                    Select the period of time you'd like to get the logs for
                                </div>
                                <div className="date-wrapper">
                                    <div>Start date</div>
                                    <div>End date</div>
                                </div>
                                <DatePicker.RangePicker
                                    defaultValue={[moment().subtract(1, 'days'), moment()]}
                                    format={dateFormat}
                                    onChange={handleDate}
                                />
                                <div className="btn-wrapper">
                                    <Button
                                        type='primary'
                                        onClick={() => handleLogs(startDate, endDate)}
                                        disabled={isLogsDisabled}
                                    >
                                        Get logs
                                    </Button>
                                </div>
                            </div>
                            : renderBackup()
                        }
                    </LogsBackupWrapper>
                )
        }
    }

    return (
        <Modal
            visible={visible}
            onCancel={onCancel}
            footer={null}
        >
            {renderBody()}
        </Modal>
    )
}

export default LogsAndBackupModal